import React from "react";
import { Box, CircularProgress } from "@mui/material";

/**
 * PageLoader — centred spinner for a page or section that is waiting on its first
 * API response, so an empty state doesn't flash before the data arrives.
 */
const PageLoader = ({ minHeight = 320, size = 36, sx = {} }) => (
  <Box
    role="status"
    aria-label="Loading"
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      minHeight,
      ...sx,
    }}
  >
    <CircularProgress size={size} />
  </Box>
);

export default PageLoader;
